import React from "react";
import { FormInstance } from "antd/lib/form";

const EditableTableContext = React.createContext<FormInstance | undefined>(undefined);

export default EditableTableContext;
